// IngestErrorCode — stable identifiers for ingest-pipeline failures.
//
// Why a stable enum:
//   - admin/ingest_runs.error_code column lets陛下 query "all wall-clock kills"
//     etc. without grepping free-text error_message
//   - frontend friendly-error maps code → 一句话描述 (CLAUDE.md §10:
//     end-user 主母 must NEVER see a stack trace)
//   - enum strings are part of the worker↔frontend SSE protocol;
//     never rename in place — only add new codes
//
// Coverage philosophy (§3 of the diagnosis run, 19BD-PROD):
//   ORCHESTRATOR_*  — pipeline-level failures (schema, hard stage error)
//   LLM_*           — model-vendor failures (timeout, 5xx, invalid output)
//   WORKER_*        — Cloudflare runtime failures (wall-clock kill etc.)
//   NETWORK_*       — transport-layer (client abort, connection drop)
//   BUDGET_*        — budget guard tripped
//   VALIDATION_*    — request schema rejected before pipeline started
//   UNKNOWN         — fallback; should be rare once admin telemetry is mature
export const INGEST_ERROR_CODES = [
    'ORCHESTRATOR_SCHEMA_FAIL',
    'ORCHESTRATOR_EXTRACT_CASES_FAIL',
    'LLM_TIMEOUT',
    'LLM_PROVIDER_5XX',
    'LLM_OUTPUT_INVALID',
    'BUDGET_EXCEEDED',
    'WORKER_WALL_CLOCK',
    'NETWORK_ABORT',
    'VALIDATION_FAILED',
    'PROVIDER_INIT_FAILED',
    'UNKNOWN',
];
/**
 * 一句话用户可见描述（中文 · UI 直接显示）。陛下要求：用户只看 [CODE] + 描述，
 * 不展开 stack。每条 ≤ 16 chars 以适配窄屏 chip。
 */
export const INGEST_ERROR_DESCRIPTIONS = {
    ORCHESTRATOR_SCHEMA_FAIL: 'AI 输出整体格式异常',
    ORCHESTRATOR_EXTRACT_CASES_FAIL: '章节抽取失败',
    LLM_TIMEOUT: 'AI 调用超时',
    LLM_PROVIDER_5XX: 'AI 服务暂时不可用',
    LLM_OUTPUT_INVALID: 'AI 输出无法解析',
    BUDGET_EXCEEDED: '本次额度已用尽',
    WORKER_WALL_CLOCK: '生成超时（超过单次上限）',
    NETWORK_ABORT: '连接中断',
    VALIDATION_FAILED: '请求参数无效',
    PROVIDER_INIT_FAILED: 'AI 服务初始化失败',
    UNKNOWN: '未知错误',
};
export function isIngestErrorCode(s) {
    return typeof s === 'string' && INGEST_ERROR_CODES.includes(s);
}
/**
 * Structured pipeline error. Worker throws this from orchestrator / handler;
 * frontend re-throws it from staged-ingest-client when a `fatal` SSE event
 * arrives. friendly-error.toFriendlyError() narrows on `instanceof` to surface
 * `[CODE] 描述` to the user.
 *
 * Carries `cause` for forensic logging (admin error_message column / wrangler
 * tail), kept opaque to the user.
 */
export class IngestPipelineError extends Error {
    code;
    name = 'IngestPipelineError';
    constructor(code, message, options) {
        super(message, options);
        this.code = code;
    }
}
//# sourceMappingURL=codes.js.map